import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
	position: relative;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
	background-color: #f0f0f0;
	height: 48px;
`;

export const HeaderTitle = styled.p`
	flex: 1;
	font-family: 'Segoe UI', sans-serif;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	color: #262626;
	text-align: center;
	margin: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const InfoSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 16px 24px;
	background-color: #f8f8f8;
`;

export const InfoRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
`;

export const InfoItem = styled.div`
	flex: 1;
	font-family: 'Segoe UI', sans-serif;
	font-size: 14px;
	line-height: 16px;
	color: #262626;

	&.center {
		text-align: center;
	}

	&.right {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 8px;
	}
`;

export const Label = styled.span`
	font-weight: 600;
`;

export const Value = styled.span`
	font-weight: 400;
	letter-spacing: -0.07px;
`;

export const StatusContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const StatusDot = styled.div<{ $color?: string }>`
	width: 8px;
	height: 8px;
	border-radius: 100px;
	background-color: ${({ $color }) => $color || '#ffb40a'};
`;

export const StatusText = styled.span`
	font-family: 'Segoe UI', sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #262626;
	letter-spacing: -0.07px;
`;

export const DescriptionRow = styled.div`
	display: flex;
	width: 100%;
`;

export const DescriptionText = styled.p`
	flex: 1;
	font-family: 'Segoe UI', sans-serif;
	font-size: 14px;
	line-height: 16px;
	color: #262626;
	margin: 0;

	span.label {
		font-weight: 600;
	}

	span.value {
		font-weight: 400;
		letter-spacing: -0.07px;
	}
`;

export const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: #e6e6e6;
`;

export const TasksHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
	background-color: #f0f0f0;
	height: 48px;
`;

export const TasksHeaderTitle = styled.p`
	flex: 1;
	font-family: 'Segoe UI', sans-serif;
	font-weight: 600;
	font-size: 14px;
	line-height: 16px;
	color: #262626;
	text-align: center;
	margin: 0;
`;

export const TaskRow = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	background-color: #f8f8f8;

	&:last-child {
		border-radius: 0 0 8px 8px;
	}
`;

export const TaskCell = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
	height: 48px;
	font-family: 'Segoe UI', sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #262626;
	text-align: center;
	letter-spacing: -0.07px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const TaskDivider = styled.div`
	width: 1px;
	height: 36px;
	background-color: #e6e6e6;
`;

export const MoreActionsButton = styled.button`
	position: absolute;
	top: 8px;
	right: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px;
	background-color: #ffffff;
	border: 1px solid #e6e6e6;
	border-radius: 4px;
	cursor: pointer;

	&:hover {
		background-color: #f8f8f8;
	}
`;

export const PaginationContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;
	width: 100%;
	margin-top: 16px;
`;

export const PaginationText = styled.p`
	flex: 1;
	font-family: 'Segoe UI', sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #262626;
	letter-spacing: -0.07px;
	margin: 0;
`;

export const PaginationButtons = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const PaginationArrow = styled.button<{ $disabled?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	background: transparent;
	border: none;
	cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
	opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

	svg {
		width: 7px;
		height: 13px;
		fill: #e6e6e6;
	}
`;

export const PaginationNumber = styled.button<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 8px 12px;
	border-radius: 4px;
	border: none;
	cursor: pointer;
	font-family: 'Segoe UI', sans-serif;
	font-weight: 600;
	font-size: 14px;
	line-height: 16px;

	background-color: ${({ $active }) => ($active ? '#e6eaf8' : '#f0f0f0')};
	color: ${({ $active }) => ($active ? '#002fbb' : '#bfbfbf')};

	&:hover {
		background-color: ${({ $active }) => ($active ? '#e6eaf8' : '#e6e6e6')};
	}
`;

export const EmptyState = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 32px;
	background-color: #f8f8f8;
	font-family: 'Segoe UI', sans-serif;
	font-size: 14px;
	color: #bfbfbf;
`;
